import moment from 'moment';
import { applicationAccentOptions, defaultApplicationAccent, releaseArtworkOptions } from '../config/whatsNewConfig';

export const searchableText = (item) => `${item?.title || ''} ${item?.description || ''} ${item?.application?.label || ''}`
    .replace(/<[^>]*>/g, ' ')
    .toLowerCase();

export const getReleaseArtwork = (item) => {
    const releaseText = searchableText(item);
    const releaseTitle = (item?.title || '').trim().toLowerCase();
    if (releaseTitle.includes('home')) return { isHome: true, alt: 'Home Page' };
    const titleMatch = releaseArtworkOptions.find(option => option.keywords.some(keyword => releaseTitle.includes(keyword)));
    if (titleMatch) return titleMatch.artwork;
    return releaseArtworkOptions.find(option => option.keywords.some(keyword => releaseText.includes(keyword)))?.artwork || null;
};

export const getReleaseAccent = (item) => {
    const releaseTitle = (item?.title || '').trim().toLowerCase();
    if (releaseTitle.includes('home')) return defaultApplicationAccent;
    const releaseText = searchableText(item);
    return applicationAccentOptions.find(option => option.keywords.some(keyword => releaseText.includes(keyword)))?.accent
        || defaultApplicationAccent;
};

export const getReleaseStatus = (item) => {
    const apiStatus = item?.release_status ?? item?.releaseStatus ?? item?.status;
    const normalizedStatus = String(apiStatus ?? '').trim().toLowerCase().replace(/[_-]+/g, ' ');
    if (['in development', 'development', 'building', 'in progress'].includes(normalizedStatus)) {
        return { label: 'In development', className: 'is-in-development' };
    }
    if (['user testing', 'testing', 'qa', 'quality assurance'].includes(normalizedStatus)) {
        return { label: 'User testing', className: 'is-user-testing' };
    }
    if (['planned', 'on the roadmap', 'roadmap', 'backlog'].includes(normalizedStatus)) {
        return { label: 'Planned', className: 'is-planned' };
    }
    const isReleased = typeof item?.is_released === 'boolean'
        ? item.is_released
        : ['released', 'published', 'live', 'completed', 'complete'].includes(normalizedStatus)
        || (!normalizedStatus && moment(item?.release_date).isSameOrBefore(moment(), 'day'));

    return isReleased
        ? { label: 'Released', className: 'is-released' }
        : { label: 'In development', className: 'is-in-development' };
};

export const getReleaseEnhancement = (item) => null;
